/**
 * @class PartnerInfoDetail
 * 업체정보
 */
export default class PartnerInfoDetail {
  constructor() {
    this.sWrapper = '_wrapPartnerInfoDetail';

    // PartnerInfoDetail은 여러 곳에서 호출할 수 았으므로,
    // 이벤트 위임 방식으로 setEvent 구성해야 함
    this.setEvent();

    // 필요 data 유효 확인
    const { partnerInfoDetail } = TMON.oApp.htStorage;
    if (!partnerInfoDetail) return;

    this.render();
  }

  setEvent() {
    // PartnerInfoDetail은 여러 곳에서 호출할 수 았으므로,
    // 이벤트 위임 방식으로 setEvent 구성해야 함
    $('#_wrapPartnerInfoDetail').on(
      'click',
      '[data-role=showCurrentLocation]',
      this.showCurrentLocation
    );
    // html protocol 변경으로 인해 beforeunload event를 발생시키는 것을 방지
    $(`#${this.sWrapper}`).on('click', '[data-role=callToPartner]', () => {
      TMON.oApp.setStorage('bBlockWindowUnloadEvent', true);
    });
  }

  clearEvent() {
    $('#_wrapPartnerInfoDetail').off(
      'click',
      '[data-role=showCurrentLocation]'
    );
  }

  // TODO: https 지원 시 기능 구현
  showCurrentLocation = e => {
    if (navigator.geolocation) {
      // GPS를 지원하면
      navigator.geolocation.getCurrentPosition(
        position => {
          TMON.oApp.setStorage('setCurrentLocation', {
            sWrapperId: 'partnerInfoDetailMap',
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        error => {
          // TODO: 테스트 코드 제거
          console.error(error);
          TMON.oApp.setStorage('setCurrentLocation', {
            sWrapperId: 'partnerInfoDetailMap',
            lat: 37.2939104,
            lng: 127.2003777,
          });
        },
        {
          enableHighAccuracy: false,
          maximumAge: 0,
          timeout: Infinity,
        }
      );
    } else {
      alert('GPS를 지원하지 않습니다');
    }

    e.preventDefault();
  };

  update(sStorageKey) {
    switch (sStorageKey) {
      case 'partnerInfoDetail':
        this.render();
        break;
      default:
        break;
    }
  }

  render = () => {
    const {
      shopName,
      address,
      sPhoneNoToCall,
      sFindMapUrl,
      bIsMultiPartner,
    } = TMON.oApp.htStorage.partnerInfoDetail;

    const sHtml = `<dl class="tit">
                <dt>${bIsMultiPartner ? '다지점 | ' : ''}${shopName}</dt>
                <dd>${address}</dd>
            </dl>
            <div class="btn">
                <a data-role="callToPartner"  href="tel:${sPhoneNoToCall}" data-tlarea="CBTN" data-tlord="1"><i class="ico_tel"></i><strong>전화걸기</strong></a>
                ${
                  TMON.oApp.sPlatform === 'MA'
                    ? '<a data-role="showCurrentLocation" href="#none" data-tlarea="MBTN" data-tlord="3"><i class="ico_location"></i><strong>현재위치</strong></a>'
                    : ''
                }
                <a href="${sFindMapUrl}" target="_blank"><i class="ico_road" data-tlarea="MBTN" data-tlord="2"></i><strong>길찾기</strong></a>
            </div>`;

    $(`#${this.sWrapper}`).html(sHtml);
  };
}
